import './portalFonts.css';

export const DEFAULT_PORTAL_FONT = 'figtree';

export const PORTAL_FONTS = [
  {
    key: 'figtree',
    label: 'Figtree',
    cssFamily: "'BConnect Figtree', Arial, sans-serif",
  },
  {
    key: 'open_sans',
    label: 'Open Sans',
    cssFamily: "'BConnect Open Sans', Arial, sans-serif",
  },
  {
    key: 'roboto',
    label: 'Roboto',
    cssFamily: "'BConnect Roboto', Arial, sans-serif",
  },
  {
    key: 'libre_baskerville',
    label: 'Libre Baskerville',
    cssFamily: "'BConnect Libre Baskerville', Georgia, 'Times New Roman', serif",
  },
  {
    key: 'lora',
    label: 'Lora',
    cssFamily: "'BConnect Lora', Georgia, 'Times New Roman', serif",
  },
  {
    key: 'playfair_display',
    label: 'Playfair Display',
    cssFamily: "'BConnect Playfair Display', Georgia, 'Times New Roman', serif",
  },
];

const PORTAL_FONT_BY_KEY = Object.fromEntries(
  PORTAL_FONTS.map((font) => [font.key, font])
);

export const getPortalFont = (key) =>
  PORTAL_FONT_BY_KEY[key] || PORTAL_FONT_BY_KEY[DEFAULT_PORTAL_FONT];

export const getPortalFontCssFamily = (key) => getPortalFont(key).cssFamily;
